import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'Produs nou',
  tabs: {
    [Tab.General]: 'General',
    [Tab.NutritionInfo]: 'Informații nutriționale',
  },
  form: {
    categories: {
      label: 'Categorii',
    },
    printer: {
      label: 'Imprimantă',
    },
    name: {
      label: 'Nume',
      placeholder: 'Cheeseburger',
    },
    description: {
      label: 'Descriere',
      placeholder: 'Pateu de vită 180g, salată, roșii, castraveți, jalapenos și sos yuppi',
    },
    external_id: {
      label: 'Ref {{integration}}',
      placeholder: 'ex. referință SKU HubRise',
      read_only_hint:
        'Editabil doar dacă o integrare HubRise este conectată și sincronizarea meniului este dezactivată.',
    },
    price: {
      label: 'Preț de bază',
    },
    has_smart_pricing: {
      label: 'Prețuri speciale pentru ridicare și livrare',
    },
    pickup_price: {
      label: 'Preț ridicare',
      placeholder: 'Nespecificat',
    },
    delivery_price: {
      label: 'Preț livrare',
      placeholder: 'Nespecificat',
    },
    image: {
      label: 'Imagine (opțional)',
    },
    has_combo_tax: {
      label: 'Are taxă combo',
    },
    is_available: {
      label: 'În stoc',
      subtitle: 'Afișat în meniu',
    },
    is_visible: {
      label: 'Vizibil',
      title: 'Vizibil în meniu',
      subtitle_on: 'Clienții pot vedea acest articol',
      subtitle_off: 'Ascuns de toți clienții',
    },
    is_available_for_pickup: {
      label: 'Disponibil pentru ridicare',
      subtitle_on: 'Clienții pot comanda pentru ridicare',
      subtitle_off: 'Ascuns din meniul de ridicare',
    },
    is_available_for_delivery: {
      label: 'Disponibil pentru livrare',
      subtitle_on: 'Clienții pot comanda pentru livrare',
      subtitle_off: 'Ascuns din meniul de livrare',
    },
    modifiers: {
      label: 'Modificatori',
    },
  },
  labels: {
    smart_pricing_update_warning:
      'Prin actualizare, toate regulile de prețuri inteligente existente pentru acest produs vor fi rescrise.',
    smart_pricing_remove_warning:
      'După salvare, toate regulile de prețuri inteligente existente pentru acest produs vor fi eliminate.',
  },
  availability: {
    title: 'Disponibilitate',
    helper:
      'Vizibilitatea este comutatorul principal. Dezactivați un canal pentru a ascunde acest articol de la clienții de ridicare sau livrare fără a-l elimina din meniu.',
    status: {
      both: 'Ambele canale',
      pickup_only: 'Doar ridicare',
      delivery_only: 'Doar livrare',
      hidden: 'Ascuns',
      no_channels: 'Niciun canal',
    },
    warning: {
      no_channels: 'Acest articol este vizibil, dar nu disponibil pe niciun canal — clienții nu îl vor putea comanda.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Doar ridicare',
      delivery_only: 'Doar livrare',
      no_channels: 'Niciun canal',
    },
  },
  buttons: {
    save: 'Salvați',
    close: 'Închideți',
  },
  toasts: {
    changes_got_saved: 'Modificările au fost salvate cu succes!',
  },
};
